var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
var AuthRepository_1;
import { IAPIHTTPDataSourceType } from '../../DataSource/APIHTTPDataSource/IAPIHTTPDataSource';
import { IStorageDataSourceType } from '../../DataSource/StorageDataSource/IStorageDataSource';
import { ICacheDataSourceType } from '../../DataSource/CacheDataSource/ICacheDataSource';
import { StateMap } from './../../../Domain/DTOs/Module/ModuleDTO';
import { ILegacyAPIHTTPDataSourceType } from '../../DataSource/LegacyAPIHTTPDataSource/ILegacyAPIHTTPDataSource';
import { injectable } from '../../Decorators/Injectable';
import { inject } from '../../Decorators/Inject';
let AuthRepository = AuthRepository_1 = class AuthRepository {
    constructor(storageDataSource, dataSource, legacyDataSource, cache) {
        this.storageDataSource = storageDataSource;
        this.dataSource = dataSource;
        this.legacyDataSource = legacyDataSource;
        this.cache = cache;
        this.getSID().observe(this, sid => {
            this.dataSource.setSID(sid);
            this.legacyDataSource.setSID(sid);
        });
        this.getLastSID().observe(this, sid => {
            this.dataSource.setLastSID(sid);
            this.legacyDataSource.setLastSID(sid);
        });
    }
    setOnInvalidAuthorization(fn) {
        return this.dataSource.setOnInvalidAuthorization(fn);
    }
    getLastSID() {
        return this.cache.getCache(StateMap.last_sid).data;
    }
    setLastSID(sid) {
        this.cache.updateCache(StateMap.last_sid, sid);
        this.dataSource.setLastSID(sid);
        this.legacyDataSource.setLastSID(sid);
        this.storageDataSource.set(AuthRepository_1.sidKey, sid);
        return this.getLastSID();
    }
    getSID() {
        const observable = this.cache.getCache(StateMap.sid).data;
        if (!observable.value) {
            this.storageDataSource.get(AuthRepository_1.sidKey).then(value => value && observable.next(value));
        }
        return observable;
    }
    setSID(sid) {
        this.cache.updateCache(StateMap.sid, sid);
        this.dataSource.setSID(sid);
        this.legacyDataSource.setSID(sid);
        this.storageDataSource.set(AuthRepository_1.sidKey, sid);
        return this.getSID();
    }
};
AuthRepository.sidKey = 'sid_token';
AuthRepository = AuthRepository_1 = __decorate([
    injectable({ type: 'singleton' }),
    __param(0, inject(IStorageDataSourceType)),
    __param(1, inject(IAPIHTTPDataSourceType)),
    __param(2, inject(ILegacyAPIHTTPDataSourceType)),
    __param(3, inject(ICacheDataSourceType)),
    __metadata("design:paramtypes", [Object, Object, Object, Object])
], AuthRepository);
export { AuthRepository };
